import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {ControlType, FormItem} from './item.model';

@Component({
    selector: 'app-form-permissions-item',
    templateUrl: './form-permissions-item.component.html',
    styleUrls: ['./form-permissions-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormPermissionsItemComponent {

  readonly itemForm = input<FormItem>(undefined);
  readonly index = input<number>(undefined);

  FieldTypes = ControlType;

}
